import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '~/components';
import { FormCad } from '../components';
import initialData from './initialData';
import schema from './schema'
import { Button } from 'react-bootstrap';
import { updateQuestaoAnalise, loadQuestaoAnalises, showQuestaoAnalise  } from '~/store/modules/questao_analise/action';


const Edit = () => {
  let history = useHistory();
  const [QuestaoEdit, setQuestaoEdit] = useState(initialData);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const {tipo_meio_analise_id, questao_id} = useParams();
  const { questao_analise, errors } = useSelector(({ QuestaoAnaliseReducer }) => QuestaoAnaliseReducer);

  useEffect(() => {
    dispatch(showQuestaoAnalise(questao_id));
  }, [dispatch, questao_id]);

  useEffect(() => {
    if (questao_analise.id === parseInt(questao_id)) {
      setQuestaoEdit(questao_analise);
    }
  }, [questao_analise, questao_id]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setUpdated(true);
    }
  }, [errors]);

  useEffect(() => {
    if (updated) {
      Swal.fire('Sucesso', 'Registro atualizado com sucesso!', 'success').then(
        () => {
          history.goBack();
        }
      );
    }
  }, [updated, history, dispatch, questao_id]);

  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(QuestaoEdit)) {
      let yup_errors = {};
      schema.validate(QuestaoEdit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      console.log('chegou aqui pow');
      await dispatch(updateQuestaoAnalise(QuestaoEdit, questao_id));
      await dispatch(loadQuestaoAnalises({
        where: `tipo_meio_analise_id:${tipo_meio_analise_id}`,
      }));
      await setUpdated(true);
    }

  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Questões para APIA e ATIA</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {questao_analise.id === parseInt(questao_id) ? (
              <FormCad
                errors={errorsValidate}
                handleSubmit={handleSubmit}
                questaoAnalise={QuestaoEdit}
                schema={schema}
                setQuestaoAnalise={setQuestaoEdit}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </Button>
        <button
          className="btn btn-success"
          form="form_questaoAnalise"
          type="submint"
        >
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
